import { logFormData } from 'shared/lib/logFormData';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TCreditPurposeFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setCreditPurposeInfo } from 'entities/creditForm';

import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo/CreditPurposeInfo.texts';

export const submitCreditPurposeForm =
  (actualData: TCreditPurposeFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('CreditPurposeInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([0], CreditPurposeInfoTexts, 'manual', analyticsOverrides));
    dispatch(setCreditPurposeInfo({ data: actualData, isFullFilled: true }));
  };
